import * as Yup from 'yup';

const validationSchema = ({ t }) => Yup.object().shape({
  name: Yup.string()
    .typeError('Field must be string !')
    .required(t('general.message.field_required')),
  range_start: Yup.string()
    .typeError('Field must be string !')
    .required(t('general.message.field_required')),
  range_end: Yup.string()
    .typeError('Field must be string !')
    .required(t('general.message.field_required')),
  order: Yup.string()
    .typeError('Field must be string !')
    .required(t('general.message.field_required')),
});

export default validationSchema;
